const ENUserGroup = {
	"Adicionar Grupo de Usuários": "Add User Group",
	"Administrador": "Administrator",
	"Alterar Grupo de Usuários": "Edit User Group",
	"Deseja realmente excluir o grupo de usuários": "Do you really want to delete the user group",
	"Digite o grupo de usuários para excluí-lo": "Enter the user group to delete",
	"Erro ao adicionar grupo de usuários": "Error adding user group",
	"Erro ao alterar grupo de usuários": "Error changing user group",
	"Erro ao copiar grupo de usuários": "Error copying user group",
	"Erro ao excluir grupo de usuário": "Error deleting user group",
	"Este grupo de usuários possui usuários cadastrados": "This user group has registered users",
	"Exclusão de grupo de usuários": "Delete user group",
	"Grupo de Empresa é requerida": "Company Group is required",
	"Grupo de Empresas": "Company Group",
	"Grupo de usuários adicionado com sucesso": "User group successfully added",
	"Grupo de usuários alterado com sucesso": "User group successfully changed",
	"Grupo de usuários copiado com sucesso": "User group successfully copied",
	"Grupo de usuários excluído com sucesso": "User group successfully deleted",
	"Grupo de Usuários": "User Group",
	"Novo Grupo de Usuários": "New User Group",
	"Página Inicial é requerida": "Home Page is required"
};

export default ENUserGroup;
